<template>
<div class="wraper">
  <div class="header clearfix">
    <a href="javascript:;" class="btn btn-xs btn-success pull-left" @click="prev">上月</a>
    <a href="javascript:;" style="margin-top: 0;" class="btn btn-xs btn-success pull-right" @click="next">下月</a>
    <div class="text-center color-green">{{+realYear}}年{{+realMonth + 1}}月</div>
  </div>
  <table class="calendar">
    <thead>
      <tr>
        <td v-for="day in days" track-by="$index">{{day}}</td>
      </tr>
    </thead>
    <tbody>
      <tr v-for="week in calendar" track-by="$index">
        <td
          :class="{
            after: day.after,
            before: day.before,
            select: selects[day.date] && selects[day.date].select
          }"
          v-for="day in week"
          track-by="$index"
          @click="dayClick(day.date)"
      >{{day.dayOfMonth}}</td>
      </tr>
    </tbody>
  </table>
</div>
</template>
<script>
  // import moment from 'moment'
  import { isEqual } from 'lodash'
  export default {
    methods: {
      createCalendar,
      prev () {
        this.month--
      },
      next () {
        this.month++
      },
      dayClick (item) {
        if (!this.selects[item] || !this.selects[item].select) {
          this.$set(`selects["${item}"]`, {
            select: true
          })
        } else {
          this.selects[item].select = false
        }
      },
      bind () {
        let obj = {}
        this.dates.forEach((date) => {
          obj[date] = {
            select: true
          }
        })
        this.$set('selects', obj)
      }
    },
    props: {
      'year': {
        type: Number,
        default: new Date().getFullYear()
      },
      'month': {
        type: Number,
        default: new Date().getMonth()
      },
      'dates': {
        type: Array,
        default () {
          return []
        },
        twoWay: true
      }
    },
    data () {
      return {
        days: ['日', '一', '二', '三', '四', '五', '六'],
        selects: {}
      }
    },
    computed: {
      calendar () {
        return createCalendar(this.year, this.month)
      },
      realYear () {
        return new Date(this.year, this.month).getFullYear()
      },
      realMonth () {
        return new Date(this.year, this.month).getMonth()
      }
    },
    watch: {
      dates (val, oldVal) {
        if (!isEqual(val, Object.keys(this.selects).filter((key) => this.selects[key] && this.selects[key].select))) {
          this.bind()
        }
      },
      selects: {
        handler (val, oldVal) {
          this.$set('dates', Object.keys(this.selects).filter((key) => this.selects[key] && this.selects[key].select))
        },
        deep: true
      }
    }
  }

  /* month 范围 0 - 11 */
  function createCalendar (year, month) {
    let result = []

    // get first date and last date of the month
    let firstDate = new Date(year, +month, 1)
    let lastDate = new Date(year, +month + 1, 0)

    let firstSunday = getFirstSunday(firstDate)
    let lastSaturday = getLastSaturday(lastDate)

    /* eslint-disable no-unmodified-loop-condition */
    for (let iterator = new Date(firstSunday); iterator <= lastSaturday; iterator.setDate(iterator.getDate() + 1)) {
      if (+iterator.getDay() === 0) {
        var week = []
        result.push(week)
      }
      week.push({
        dayOfMonth: iterator.getDate(),
        date: yyyymmdd(iterator),
        before: iterator < firstDate,
        after: iterator > lastDate
      })
    }

    return result
  }

  function getFirstSunday (firstDate) {
    let offset = firstDate.getDay()
    let result = new Date(firstDate)
    result.setDate(firstDate.getDate() - offset)
    return result
  }

  function getLastSaturday (lastDate) {
    let offset = 6 - lastDate.getDay()
    let result = new Date(lastDate)
    result.setDate(lastDate.getDate() + offset)
    return result
  }

  function yyyymmdd (date) {
    let yyyy = date.getFullYear()
    let mm = date.getMonth() + 1
    let dd = date.getDate()

    return yyyy + '-' + (+mm >= 10 ? mm : ('0' + mm)) + '-' + (+dd >= 10 ? dd : ('0' + dd))
  }

</script>
<style scoped>
  .wraper {
    margin: 0 6px;
  }
  .header {
    padding: 12px 0 5px;
  }
  .calendar {
    width: 100%;
    border: 1px solid #ddd;
    border-collapse: collapse;
    color: #555;
  }
  .calendar thead {
    font-weight: bold;
    border-bottom: 1px solid #ccc;
  }
  .calendar td {
    text-align: center;
    vertical-align: center;
    padding: 10px;
  }
  .calendar tbody td {
    border: 1px solid #ddd;
  }
  .before,
  .after {
    color: #aaa;
  }
  .highlight {
    color: red;
  }
  .select {
    background-color: #28BDB7 !important;
    color: #fff;
  }
  .calendar tbody td:hover {
    background-color: #eaeaea;
    cursor: pointer;
  }
  .color-green {
    color: #00b38a;
  }
</style>



/** WEBPACK FOOTER **
 ** DCalendar.vue?dc493cfc
 **/